export const DEFAULT_COLLECTION_SHARE_PERMISSIONS = {
  permissionLevel: 0,
  sampleDetailLevel: 10,
  reactionDetailLevel: 10,
  wellplateDetailLevel: 10,
  screenDetailLevel: 10,
  elementDetailLevel: 10,
};
